// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "./Utilities/JotaiAtoms.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "./Utilities/ApiEndpoint.bs.js";
import * as ErrorOccured$OrcaPaymentPage from "./Components/ErrorOccured.bs.js";
import * as CollectWidget$OrcaPaymentPage from "./CollectWidget.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "./Utilities/PaymentHelpers.bs.js";
import * as PaymentMethodCollectTypes$OrcaPaymentPage from "./Types/PaymentMethodCollectTypes.bs.js";
import * as PaymentMethodCollectUtils$OrcaPaymentPage from "./Utilities/PaymentMethodCollectUtils.bs.js";

function PaymentMethodCollectElement(props) {
  let logger = props.logger;
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let localeString = match.localeString;
  let match$1 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let themeObj = match$1.themeObj;
  let keys = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let options = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.paymentMethodCollectOptionAtom);
  let match$2 = React.useState(() => PaymentMethodCollectUtils$OrcaPaymentPage.defaultAvailablePaymentMethods);
  let setAvailablePaymentMethods = match$2[1];
  let availablePaymentMethods = match$2[0];
  let match$3 = React.useState(() => PaymentMethodCollectUtils$OrcaPaymentPage.defaultAvailablePaymentMethodTypes);
  let setAvailablePaymentMethodTypes = match$3[1];
  let availablePaymentMethodTypes = match$3[0];
  let match$4 = React.useState(() => false);
  let setLoader = match$4[1];
  let loader = match$4[0];
  let match$5 = React.useState(() => {});
  let setSecondsUntilRedirect = match$5[1];
  let secondsUntilRedirect = match$5[0];
  let match$6 = React.useState(() => false);
  let setShowStatus = match$6[1];
  let showStatus = match$6[0];
  let match$7 = React.useState(() => PaymentMethodCollectUtils$OrcaPaymentPage.defaultStatusInfo);
  let setStatusInfo = match$7[1];
  let statusInfo = match$7[0];
  React.useEffect(() => {
    let availablePM = [];
    let availablePMT = [];
    options.enabledPaymentMethods.forEach(pm => {
      switch (pm.TAG) {
        case "Card" :
          if (!availablePM.includes("Card")) {
            availablePM.push("Card");
            availablePMT.push({
              TAG: "Card",
              _0: "Debit"
            });
            return;
          } else {
            return;
          }
        case "BankRedirect" :
          if (!availablePM.includes("BankRedirect")) {
            availablePM.push("BankRedirect");
          }
          if (!availablePMT.includes(pm)) {
            availablePMT.push(pm);
            return;
          } else {
            return;
          }
        case "BankTransfer" :
          if (!availablePM.includes("BankTransfer")) {
            availablePM.push("BankTransfer");
          }
          if (!availablePMT.includes(pm)) {
            availablePMT.push(pm);
            return;
          } else {
            return;
          }
        case "Wallet" :
          if (!availablePM.includes("Wallet")) {
            availablePM.push("Wallet");
          }
          if (!availablePMT.includes(pm)) {
            availablePMT.push(pm);
            return;
          } else {
            return;
          }
      }
    });
    setAvailablePaymentMethods(param => availablePM);
    setAvailablePaymentMethodTypes(param => availablePMT);
  }, [options.enabledPaymentMethods]);
  React.useEffect(() => {
    let match = options.returnUrl;
    if (match !== undefined && showStatus) {
      setSecondsUntilRedirect(param => 5);
      let interval = setInterval(() => setSecondsUntilRedirect(prev => {
        if (prev !== undefined) {
          if (prev > 0) {
            return prev - 1 | 0;
          } else {
            return prev;
          }
        } else {
          return 5;
        }
      }), 1000);
      setTimeout(() => {
        clearInterval(interval);
        let url = new URL(match);
        url.searchParams.set("payout_id", options.payoutId);
        url.searchParams.set("status", PaymentMethodCollectUtils$OrcaPaymentPage.getPayoutStatusString(statusInfo.status));
        Utils$OrcaPaymentPage.openUrl(url.href);
      }, 5010);
    }
  }, [showStatus]);
  let handleSubmit = pmd => {
    setLoader(param => true);
    let flow = options.flow;
    let pmdBody = PaymentMethodCollectUtils$OrcaPaymentPage.formBody(flow, pmd);
    let createPaymentMethodPromiseWrapped = () => Core__Promise.$$catch(PaymentHelpers$OrcaPaymentPage.createPaymentMethod(Core__Option.getOr(keys.clientSecret, ""), keys.publishableKey, logger, "", ApiEndpoint$OrcaPaymentPage.getApiEndPoint(undefined, undefined), pmdBody).then(res => {
      console.warn("DEBUGG RES", res);
      return Promise.resolve();
    }), err => {
      console.error("DEBUGG ERR", err);
      return Promise.resolve();
    }).finally(() => setLoader(param => false));
    let confirmPayoutPromiseWrapper = () => {
      let endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(undefined, undefined);
      return Core__Promise.$$catch(PaymentHelpers$OrcaPaymentPage.confirmPayout(Core__Option.getOr(keys.clientSecret, ""), keys.publishableKey, logger, "", endpoint, pmdBody, options.payoutId).then(res => {
        let data = PaymentMethodCollectTypes$OrcaPaymentPage.decodePayoutConfirmResponse(res);
        if (data !== undefined) {
          if (data.TAG === "SuccessResponse") {
            let res$1 = data._0;
            let updatedStatusInfo_status = res$1.status;
            let updatedStatusInfo_payoutId = res$1.payoutId;
            let updatedStatusInfo_message = PaymentMethodCollectUtils$OrcaPaymentPage.getPayoutStatusMessage(res$1.status, localeString);
            let updatedStatusInfo_code = res$1.errorCode;
            let updatedStatusInfo_errorMessage = res$1.errorMessage;
            let updatedStatusInfo = {
              status: updatedStatusInfo_status,
              payoutId: updatedStatusInfo_payoutId,
              message: updatedStatusInfo_message,
              code: updatedStatusInfo_code,
              errorMessage: updatedStatusInfo_errorMessage,
              reason: undefined
            };
            setStatusInfo(param => updatedStatusInfo);
          } else {
            let err = data._0;
            let updatedStatusInfo_payoutId$1 = options.payoutId;
            let updatedStatusInfo_message$1 = localeString.payoutStatusFailedMessage;
            let updatedStatusInfo_code$1 = err.code;
            let updatedStatusInfo_errorMessage$1 = err.message;
            let updatedStatusInfo_reason = err.reason;
            let updatedStatusInfo$1 = {
              status: "Failed",
              payoutId: updatedStatusInfo_payoutId$1,
              message: updatedStatusInfo_message$1,
              code: updatedStatusInfo_code$1,
              errorMessage: updatedStatusInfo_errorMessage$1,
              reason: updatedStatusInfo_reason
            };
            setStatusInfo(param => updatedStatusInfo$1);
          }
        } else {
          let updatedStatusInfo_payoutId$2 = options.payoutId;
          let updatedStatusInfo_message$2 = localeString.payoutStatusFailedMessage;
          let updatedStatusInfo$2 = {
            status: "Failed",
            payoutId: updatedStatusInfo_payoutId$2,
            message: updatedStatusInfo_message$2,
            code: undefined,
            errorMessage: undefined,
            reason: undefined
          };
          setStatusInfo(param => updatedStatusInfo$2);
        }
        return Promise.resolve();
      }), err => {
        console.error("CRITICAL - Payouts confirm failed with unknown error", err);
        let updatedStatusInfo_payoutId = options.payoutId;
        let updatedStatusInfo_message = localeString.payoutStatusFailedMessage;
        let updatedStatusInfo = {
          status: "Failed",
          payoutId: updatedStatusInfo_payoutId,
          message: updatedStatusInfo_message,
          code: undefined,
          errorMessage: undefined,
          reason: undefined
        };
        setStatusInfo(param => updatedStatusInfo);
        return Promise.resolve();
      }).finally(() => {
        setShowStatus(param => true);
        setLoader(param => false);
      });
    };
    if (flow === "PayoutLinkInitiate") {
      Core__Promise.$$catch(confirmPayoutPromiseWrapper().then(() => Promise.resolve()), param => Promise.resolve());
      return;
    }
    pmdBody.push([
      "customer_id",
      options.customerId
    ]);
    Core__Promise.$$catch(createPaymentMethodPromiseWrapped().then(() => Promise.resolve()), param => Promise.resolve());
  };
  let renderCollectWidget = () => JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        loader ? JsxRuntime.jsx("div", {
            className: "absolute h-full w-full bg-jp-gray-600 bg-opacity-80"
          }) : null,
        JsxRuntime.jsx(CollectWidget$OrcaPaymentPage.make, {
          availablePaymentMethods: availablePaymentMethods,
          availablePaymentMethodTypes: availablePaymentMethodTypes,
          primaryTheme: options.theme,
          handleSubmit: handleSubmit,
          formLayout: options.formLayout
        })
      ],
      className: "relative w-full h-min lg:w-auto lg:mx-12 lg:mt-20 lg-mb-10"
    }),
    className: "flex flex-row overflow-scroll lg:w-6/10"
  });
  let renderPayoutStatus = () => {
    let status = statusInfo.status;
    let imageSource = PaymentMethodCollectUtils$OrcaPaymentPage.getPayoutImageSource(status);
    let readableStatus = PaymentMethodCollectUtils$OrcaPaymentPage.getPayoutReadableStatus(status, localeString);
    let statusInfoFields = [{
        key: localeString.infoCardRefId,
        value: options.payoutId
      }];
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  children: options.collectorName,
                  className: "text-2xl font-semibold"
                }),
                JsxRuntime.jsx("img", {
                  className: "h-12 w-auto max-w-21",
                  alt: "o",
                  src: options.logo
                })
              ],
              className: "flex flex-row justify-between items-center w-full px-10 py-5 border-b border-jp-gray-300"
            }),
            JsxRuntime.jsx("img", {
              className: "h-40 w-40 mt-7",
              alt: "o",
              src: imageSource
            }),
            JsxRuntime.jsx("div", {
              children: readableStatus,
              className: "text-xl font-semibold mt-2.5"
            }),
            JsxRuntime.jsx("div", {
              children: statusInfo.message,
              className: "text-jp-gray-800 m text-center mx-10 mb-10"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                children: statusInfoFields.map((info, i) => JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                      children: info.key,
                      className: "text-sm text-jp-gray-900 text-right min-w-20"
                    }),
                    JsxRuntime.jsx("div", {
                      children: info.value,
                      className: "text-[11px] ml-2.5 pl-2.5 border-l border-jp-gray-300\r\n                    xs:text-xs"
                    })
                  ],
                  className: `flex flex-row items-center mb-0.5`
                }, i.toString())),
                className: "flex flex-col max-w-[500px] bg-white w-full mx-2.5\r\n            xs:mx-10"
              }),
              className: "flex border-t border-bg-jp-gray-300 py-5 w-full justify-center"
            })
          ],
          className: "flex flex-col items-center rounded-lg max-w-[500px]\r\n          xs:shadow-lg"
        }),
        secondsUntilRedirect !== undefined ? JsxRuntime.jsx("div", {
            children: localeString.linkRedirectionText(secondsUntilRedirect),
            className: "mt-10"
          }) : null
      ],
      className: "flex flex-col items-center justify-center self-center leading-none\r\n        xs:mt-auto xs:mb-auto\r\n        lg:ml-auto lg:mr-auto",
      style: {
        color: themeObj.colorText,
        fontFamily: themeObj.fontFamily,
        fontSize: themeObj.fontSizeBase
      }
    });
  };
  if (props.integrateError) {
    return JsxRuntime.jsx(ErrorOccured$OrcaPaymentPage.make, {});
  }
  let merchantLogo = options.logo;
  let merchantName = options.collectorName;
  let merchantTheme = options.theme;
  let match$8 = options.flow;
  let tmp;
  tmp = match$8 === "PayoutLinkInitiate" ? (
      showStatus ? renderPayoutStatus() : JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("p", {
                          children: options.currency + ` ` + options.amount
                        }),
                        className: "font-bold text-5xl mt-5 lg:mt-0 lg:text-3xl flex justify-start items-center"
                      }),
                      JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("img", {
                          className: "max-h-12 w-auto max-w-21 h-auto",
                          alt: "O",
                          src: merchantLogo
                        }),
                        className: "flex self-start h-12 w-auto bg-white rounded-sm"
                      })
                    ],
                    className: "flex flex-col-reverse justify-end\r\n                    lg:mx-5 lg:mt-5 lg:flex-row lg:justify-between"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                        children: localeString.payoutFromText(merchantName),
                        className: "self-center text-xl font-semibold"
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                            children: localeString.infoCardRefId,
                            className: "font-semibold text-xs"
                          }),
                          JsxRuntime.jsx("div", {
                            children: options.payoutId,
                            className: "ml-1 text-xs"
                          })
                        ],
                        className: "flex flex-row lg:mt-1"
                      })
                    ],
                    className: "lg:mx-5"
                  }),
                  JsxRuntime.jsx("div", {
                    children: localeString.linkExpiryInfo(options.sessionExpiry),
                    className: "mt-4 px-4 py-1.5 bg-gray-200 text-[13px] rounded-full w-max text-black\r\n                    lg:w-full lg:rounded-none lg:rounded-b-lg"
                  })
                ],
                className: "flex flex-col text-white w-full min-w-[300px] max-w-[520px]\r\n                  lg:rounded-md lg:shadow-lg lg:min-w-80 lg:max-w-96 lg:bg-white lg:text-black"
              }),
              className: "flex flex-col w-full h-max items-center p-6\r\n                lg:w-4/10 lg:px-12 lg:py-20 lg:h-screen lg:items-end",
              style: {
                backgroundColor: merchantTheme
              }
            }),
            renderCollectWidget()
          ]
        })
    ) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "h-12 w-auto",
                alt: "O",
                src: merchantLogo
              }),
              JsxRuntime.jsx("div", {
                children: merchantName,
                className: "ml-4 text-white self-center text-2xl font-bold"
              })
            ],
            className: "flex flex-row"
          }),
          className: "flex flex-col w-3/10 p-12",
          style: {
            backgroundColor: merchantTheme
          }
        }),
        renderCollectWidget()
      ]
    });
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: "flex flex-col h-screen min-w-[320px] overflow-hidden\r\n        lg:flex-row"
  });
}

let make = PaymentMethodCollectElement;

let $$default = PaymentMethodCollectElement;

export {
  make,
  $$default as default,
}
/* jotai Not a pure module */
